import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { Product, AddToCartEvent } from '../../../../shared/models/product.model';
import { ProductCarouselComponent } from '../product-carousel/product-carousel.component';

export interface OffersBlockData {
  sort_by?: 'newest' | 'price_asc' | 'price_desc' | 'name_asc';
  limit?: number;
  products: Product[];
}

@Component({
  selector: 'app-offers-block',
  imports: [ProductCarouselComponent],
  templateUrl: './offers-block.component.html',
  styleUrl: './offers-block.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OffersBlockComponent {
  // El padre (HomeComponent) lee el bloque `offers` del payload y pasa los
  // productos ya adaptados al shape `Product` (vía publicOfferProductToUiProduct).
  // El componente no se entera del API — solo recibe el slice listo para pintar.
  readonly data = input<OffersBlockData | null>(null);

  protected readonly products = computed(() => this.data()?.products ?? []);
  // Backend ya filtró: si el bloque llega es porque tiene ofertas. El render
  // siempre procede mientras la lista no esté vacía (caso defensivo).
  protected readonly shouldRender = computed(() => this.products().length > 0);

  addToCart = output<AddToCartEvent>();
  zoomOpen = output<Product>();
  notifyRequest = output<Product>();
  notifyCancel = output<Product>();
  cardClick = output<Product>();
  reserveClick = output<Product>();
}
